import BarChartStackedBySign from './BarChartStackedBySign'
export default BarChartStackedBySign
